import { useQuery } from '@apollo/client'

import { extractByTypename, isNotNullish } from '@local/utils'

import { useErrorToast } from '@web/hooks/useErrorToast'
import { federationApolloClient } from '@web/libs/apollo/federationClient'
import { convertUpcomingBookingItem } from '@web/pages/v5/home/UpcomingSection/helper'
import { UpcomingBookingQuery } from '@web/pages/v5/home/UpcomingSection/hooks/useUpcomingBooking.query'

interface Props {
  limit?: number
  skip?: boolean
}

export const useUpcomingBooking = ({ limit, skip }: Props = { limit: 10, skip: false }) => {
  const { data, loading, fetchMore, error } = useQuery(UpcomingBookingQuery, { variables: { limit }, skip })
  useErrorToast(error)
  const { MeSucceed } = extractByTypename(data?.me)
  const upcomingBookings = MeSucceed?.upcomingBookings

  const upcomingBookingCount = upcomingBookings?.pageInfo.totalCount ?? 0
  const upcomingBookingItems = upcomingBookings?.bookings?.filter(isNotNullish).map(convertUpcomingBookingItem) ?? []

  const nextPage = upcomingBookings?.pageInfo.nextPage
  const hasNextPage = !!upcomingBookings?.pageInfo.hasNextPage

  const upcomingBookingFetchMore = async () => {
    if (nextPage && hasNextPage && !skip) {
      return await fetchMore({
        variables: { limit, page: nextPage },
      })
    }
    return null
  }

  const resetUpcomingBooking = () => {
    federationApolloClient?.cache.modify({
      id: 'ROOT_QUERY',
      fields: {
        me(existing) {
          return {
            ...existing,
            upcomingBookings: undefined,
          }
        },
      },
    })
  }

  return {
    upcomingBookingItems,
    upcomingBookingCount,
    upcomingBookingFetchMore,
    upcomingBookingMore: hasNextPage,
    data,
    loading,
    resetUpcomingBooking,
  }
}
